module.exports = __webpack_public_path__ + "static/media/icn-incontro.266dbae3.svg";